__turbopack_context__.v({
  "app-container": "PackingInstructionsApp-module-scss-module__yaYSEG__app-container",
});
